import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface PackInfo {
  name: string;
  img: string | null;
}

export function useSetFilterOptions(setCode: string | null) {
  const [packs, setPacks] = useState<PackInfo[]>([]);
  const [rarities, setRarities] = useState<string[]>([]);
  const [types, setTypes] = useState<string[]>([]);
  const [energies, setEnergies] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFilterOptions = async () => {
      if (!setCode) {
        setPacks([]);
        setRarities([]);
        setTypes([]);
        setEnergies([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        // Charger les packs avec leurs images
        const { data: cardsData } = await supabase
          .from('cards')
          .select('pack')
          .eq('set', setCode)
          .not('pack', 'is', null);

        const uniquePackNames = [...new Set(cardsData?.map(item => item.pack))].filter(Boolean);

        // Récupérer les informations complètes des packs
        const { data: packsData } = await supabase
          .from('packs')
          .select('name, img')
          .in('name', uniquePackNames);

        // Trier les packs par nom
        const sortedPacks = (packsData || []).sort((a, b) => 
          a.name.localeCompare(b.name)
        );

        // Charger les raretés
        const { data: raritiesData } = await supabase
          .from('cards')
          .select('rarity')
          .eq('set', setCode)
          .not('rarity', 'is', null);

        // Charger les types
        const { data: typesData } = await supabase
          .from('cards')
          .select('type')
          .eq('set', setCode)
          .not('type', 'is', null);

        // Charger les énergies
        const { data: energiesData } = await supabase
          .from('cards')
          .select('energy')
          .eq('set', setCode)
          .not('energy', 'is', null);

        // Extraire les valeurs uniques
        const uniqueRarities = [...new Set(raritiesData?.map(item => item.rarity))].filter(Boolean);
        const uniqueTypes = [...new Set(typesData?.map(item => item.type))].filter(Boolean);
        const uniqueEnergies = [...new Set(energiesData?.map(item => item.energy))].filter(Boolean);

        setPacks(sortedPacks);
        setRarities(uniqueRarities.sort());
        setTypes(uniqueTypes.sort());
        setEnergies(uniqueEnergies.sort());
      } catch (error) {
        console.error('Error loading filter options:', error);
        setError(error instanceof Error ? error.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    loadFilterOptions();
  }, [setCode]);

  return { packs, rarities, types, energies, loading, error };
}